import $ from "jquery";
import _ from "../../../../lib/lodash.custom.min";
import View from "./view";
import viewHelpers from "./view-helper";
import setCarouselAnimation from "./carousel";
import {DEFAULT_STATE, DEF, COOKIE, REVIEW_HOTELS_PER_PAGE, HOTEL_ORDER_ITEM_PER_PAGE} from "./config";
import {goDetail, detailParam} from "../modules/transition";
import spookCommand, {request} from "../modules/request";
import keyword from "./keyword";
import cookie from "js-cookie";
import paramMixin, {convertServerParam} from "./param";
import {queryStringToHash, calcDayOffset, replaceHistory, dateArrayToHash} from "../modules/util";
import {makeCalendars} from "../modules/calendar";
import setState from "../modules/set-state";
import serverParam  from "./server-param";

/*
 * DOMイベントが呼ぶ関数群
 */ 
var Action = {
	init: function(ev) {
		const store = ev.data;
		const initHash = queryStringToHash(location.hash.replace(/#/, ""));
		location.hash = "";
		replaceHistory();
		store.viewstr = viewHelpers;
		store.def = {};
		store.state.changedSortText = false;
		store.state.skipSetFirstPage = false;
		paramMixin(store.state, store.def);
		request("Decoder", {
			callback: function(data) {
				Object.assign(store.def, data, DEF);
				store.def.contextPath = serverParam.contextPath;
				store.def.calendarHash = dateArrayToHash(store.def.calendar);
				store.def.startDate = store.def.calendar[calcDayOffset(data.dataVersion[0], data.decodeTime[0])];
				const lastDate = store.def.calendar[store.def.calendar.length - 1];
				store.def.months = makeCalendars(store.def.startDate.code, lastDate.code);
				Object.assign(
					store.state,
					convertServerParam(serverParam.params, store.def),
					initHash
				);

				// 初期描画時のみActionからViewを呼ぶことを許容
				// (ここでもModelへSet -> ViewでRenderができるならばそのほうが流れが統一される)
				View.dataVersion(ev);
				View.currentConditions(ev);
				View.calendarBase(ev);
				View.calendarCheckbox(ev);
				View.reviewMinMax(ev);
				View.hotelName(ev);
				View.sort(ev);

				setCarouselAnimation();
				countAll(store)
				.then(() => {
					Action.list(ev);
					Action.hotels(ev);
					if (!store.state.SPECIAL) {
						spookCommand(store, "RankingList", store.state.getParam("RankingList"));
					}
				});
				if (!store.state.SPECIAL) {
					initHistory(store, COOKIE.HIST);
				}
				store.state.set({monthIndex: store.state.monthIndex || store.state.monIdxOfDate});
			}
		});
	},
	suggestHotel: function(ev) {
		keyword.setHotelNameSuggestion();
	},
	suggestFreeword: function(ev) {
		keyword.setFreewordSuggestion();
	},
	goDetail: function(ev) {
		const param = $(this).data("param");
		setConditionHash(ev.data);
		param.backHashParam = ev.data.state.queryString;
		setHistory(param.courseKey, COOKIE.HIST);
		spookCommand(ev.data, "JumpRecord", {key: param.courseKey});
		goDetail(param, ev.data.def.contextPath);
	},
	goDetailWithoutDate: function(ev) {
		const param = $(this).data("param");
		setConditionHash(ev.data);
		param.backHashParam = ev.data.state.queryString;
		setHistory(param.courseKey, COOKIE.HIST);
		spookCommand(ev.data, "JumpRecord", {key: param.courseKey});
		goDetail(param, ev.data.def.contextPath);
	},
	goDetailCalendar: function(ev) {
		const date = $(this).data("date");
		const yyyymmdd = date.replace(/-/g, "");
		const courseIndex = ev.data.state.courseListIndex; //カレンダーを開くとsetされるindex
		const course = ev.data.state.ListMobile.course[courseIndex];
		const param = detailParam(course);
		param.backHashParam = ev.data.state.queryString;
		setConditionHash(ev.data);
		setHistory(param.courseKey, COOKIE.HIST);
		spookCommand(ev.data, "JumpRecord", {key: param.courseKey});
		goDetail(Object.assign({yyyymmdd}, param), ev.data.def.contextPath);
	},
	list: function(ev) {
		var store = ev.data;
		var param = store.state.getParam();
		var enoughParam = viewHelpers.isEnableHotelOrder(param);
		View.hotelSortTextControler(ev);
		if (param.sort === "hotel") {
			if (!enoughParam) {
				View.hidePager();
				View.hotelListErrorHtml(ev);
			} else {
				request("HotelListMobile", {
					data: param,
					callback: function(data) {
						View.showPager();
						store.state.set({HotelListMobile: data});
					},
					beforeSend: function() {
						showLoadImage("#forcia-template-list");
					}
				});
			}
		} else if (param.sort === "hotel_back") {
			ev.data.state.set({["checkedHotel"]: []});
			ev.data.state.set({["pickedHotel"]: []});
			delete param.Hotels;
			request("HotelListMobile", {
				data: param,
				callback: function(data) {
					View.showPager();
					store.state.set({HotelListMobile: data});
					store.state.set({sort: "hotel"});
				},
				beforeSend: function() {
					showLoadImage("#forcia-template-list");
				}
			});
			countAllWithoutSetPager(ev.data);
		} else {
			request("ListMobile", {
				data: param,
				callback: function(data) {
					View.showPager();
					store.state.set({ListMobile: data});
				},
				beforeSend: function() {
					showLoadImage("#forcia-template-list");
				}
			});
		}
		View.mainLayer(ev);
		View.currentConditions(ev);
		if (destHasChanged(param) && !store.state.SPECIAL) {
			spookCommand(store, "RankingList", param);
		}
	},
	closeCalendar: function(ev) {
		ev.preventDefault();
		const state = ev.data.state;
		const monthIndex = (state.date && !state.monthIsSelected) ?
						state.monIdxOfDate:
						state.monthIndex;
		state.set({
			subLayer: "",
			monthIndex: monthIndex
		});
		countAll(ev.data);
	},
	openCourseCalendar: function(ev) {
		ev.data.state.set({
			courseCalendarLayer: true,
			courseListIndex: $(this).data("courseListIndex")
		});
	},
	resetConditions: function(ev) {
		ev.preventDefault();
		ev.data.state.clear();
		const newState = $(this).data("state") || {};
		ev.data.state.set(Object.assign({}, DEFAULT_STATE, newState));
		countAll(ev.data);
		Action.list.call(this, ev);
	},
	resetBudget: function(ev) {
		ev.preventDefault();
		const state = ev.data.state;
		const ids = state.kodawariCategories["割引"].map((o) => (o.id));
		state.set({
			budget: [],
			subLayer: "",
			kodawari: _.without(state.kodawari, ...ids)
		});
		countAll(ev.data);
	},
	resetFlight: function(ev) {
		ev.preventDefault();
		const state = ev.data.state;
		const ids = state.kodawariCategories["フライト条件"].map((o) => (o.id));
		state.set({
			subLayer: "",
			kodawari: _.without(state.kodawari, ...ids)
		});
		countAll(ev.data);
	},
	resetKodawari: function(ev) {
		ev.preventDefault();
		const state = ev.data.state;
		const categories = state.kodawariCategories;
		const targets = categories["ツアー内容"].concat(
				categories["観光スポット"], categories["目的・テーマ"], categories["そのほか"]);
		const ids = _.compact(targets).map((o) => (o.id));
		state.set({
			subLayer: "",
			kodawari: _.without(state.kodawari, ...ids)
		});
		countAll(ev.data);
	},
	resetHotel: function(ev) {
		ev.preventDefault();
		const state = ev.data.state;
		const categories = state.kodawariCategories;
		const targets = categories["ホテル条件"].concat(categories["ホテル立地"], categories["部屋タイプ"]);
		const ids = _.compact(targets).map((o) => (o.id));
		state.set({
			subLayer: "",
			hotelname: "",
			checkedHotel: [],
			HotelMinPop: DEFAULT_STATE.HotelMinPop,
			HotelMaxPop: DEFAULT_STATE.HotelMaxPop,
			kodawari: _.without(state.kodawari, ...ids)
		});
		countAll(ev.data);
	},
	clearHotelName: function(ev) {
		ev.preventDefault();
		ev.data.state.set({hotelname: ""});
		countAll(ev.data);
	},
	clearFreeword: function(ev) {
		ev.preventDefault();
		ev.data.state.set({freeword: ""});
		countAll(ev.data);
	},
	hotels: function(ev) {
		reviewHotelsCommand(ev.data);
	},
	countClose: function(ev) {
		var store = ev.data;
		countAll(store).then(function(){
			store.state.set({subLayer: ""});
		});
	},
	setStateSearch: function(ev) {
		var data = setState.call(this, ev);
		if (!_.isEmpty(data)) {
			Action.list.call(this, ev);
		}
	},
	setStateCount: function(ev) {
		var store = ev.data;
		var data = setState.call(this, ev);
		if (data) {
			countAll(store);
		}
	},
	closeHotelLayer: function(ev) {
		ev.preventDefault();
		ev.data.state.set({"subLayer": ""});
		// ホテルレイヤーを閉じるときはクチコミホテル検索を実行する必要はなく、
		// 検索した場合クチコミホテルページが1ページ目にもどってしまうためそれ以外のコマンドを実行
		countWithoutUpdatingHotels(ev.data);
	},
	openArrival: function(ev) {
		//目的地レイヤーを開くときのaction
		ev.preventDefault();
		const store = ev.data;
		const nextState = $(this).data("state");
		if (nextState.subLayer === "city0") {
			// PCの地図用のレスポンスを使っているためトリッキーな実装になっている.
			// 都市を選んだ状態で再度目的地レイヤーを開くと選択中の都市の条件が含まれた状態でcity0が返ってくるため、
			// region0, country0以外の条件を含めない状態でConditionStateのデータを取得して描画する.
			const param = store.state.getParam("ConditionState");
			delete param.city0;
			delete param.country1;
			delete param.city1;
			// 異なる都市を選んだ場合、country1,city1を削除するため件数はそのままでよい
			// 選択中の都市については現在の件数をそのまま使用して件数をあわせる
			const currentCount = store.state.ConditionState.dataCount[0];
			spookCommand(store, "ConditionState", param)
				.then(() => {
					store.state.set({subLayer: "city0"});
					// actionで一部viewの調整をしてしまっているので、本来はサーバ側のレスポンスでどうにかすべき
					const $elm = $("#forcia-template-arrival-city0 .selected .forcia-count");
					$elm.html(currentCount);
				});
		} else if (nextState.subLayer === "city1") {
			const param = store.state.getParam("ConditionState");
			delete param.city1;
			spookCommand(store, "ConditionState", param)
				.then(() => {store.state.set({subLayer: "city1"});});
		} else {
			// 都市を開くとき以外は特別な処理をする必要はない
			setState.call(this, ev);
		}
	},
	arrival: function(ev) {
		// 目的地レイヤー内で地域を選択するときのaction
		ev.preventDefault();
		var store = ev.data;
		var state = $(this).data("state");
		_.each(_.keys(state), function(key) {
			store.state[key] = state[key];
		});

		if (store.state.subLayer) {
			// 目的地レイヤー内の移動では、
			// 次のレイヤー表示に必要なConditionStateのみでよい
			spookCommand(store, "ConditionState", store.state.getParam("ConditionState")) .then(function() {
				store.state.set(state);
			});
		} else {
			// レイヤーを閉じる際にはすべての件数コマンドを非同期で投げ、
			// すぐにレイヤーを閉じられるようにする。
			countAll(store);
			store.state.set(state);
		}
	},
	slideCalendar: function(ev) {
		const state = ev.data.state;
		const idx = $(this).data("monthidx");
		state.set({monthIndex: idx});
		if (state.monthIsSelected) {
			state.set({date: state.ymCurrent});
		}
		state.set({monthIndex: idx});
		calendarState(ev.data);
	},
	selectCalendarDate: function(ev) {
		ev.preventDefault();
		const calendarStateFlag = !_.isEmpty(ev.data.state._checkStock);
		const currentDate = ev.data.state.date;
		const selectDate = String($(this).data("date"));
		const nextDate = currentDate === selectDate ? "" : selectDate;
		ev.data.state.set({date: nextDate});
		if (calendarStateFlag) {
			calendarState(ev.data);
		}
	},
	checkStock: function(ev) {
		setState.call(this, ev);
		calendarState(ev.data);
	},
	checkMonth: function(ev) {
		const state = ev.data.state;
		const nextDate = this.checked ? state.ymCurrent : "";
		state.set({date: nextDate});
	},
	page: function(ev) {
		var state = ev.data.state;
		var itemPerPage;
		var dataCount;
		var params = state.getParam();
		if (params.sort === "hotel" || params.sort === "hotel_back") {
			dataCount = Number(state.ConditionState.hotelListCount[0]);
			itemPerPage = HOTEL_ORDER_ITEM_PER_PAGE;
		} else {
			dataCount = Number(state.ConditionState.dataCount[0]);
			itemPerPage = state.limit;
		}

		var offset = Number($(this).data("offset"));

		if (offset > 0 && !hasNextPage(dataCount, state.page, itemPerPage)) {
			return;
		}
		var nextPage = Math.max(state.page + offset, 1);
		state.set({page: nextPage});
		var top = $(".resultArea")[0].offsetTop;
		$(window).scrollTop(top);
		Action.list(ev);
	},
	checkReviewHotel: function(ev) {
		const checkedHotel = ev.data.state[this.name] || [];
		const newHotels = this.checked ?
				_.unique(checkedHotel.concat([this.value])) :
				checkedHotel.filter((v) => (v !== this.value));
		ev.data.state.set({[this.name]: newHotels});
		spookCommand(ev.data, "ConditionState", ev.data.state.getParam("ConditionState"));
	},
	reviewPage: function(ev) {
		const state = ev.data.state;
		const offset = Number($(this).data("offset"));
		const current = state.reviewPage || 1;
		const total = state.hotels.length;
		if (offset > 0 && !hasNextPage(total, current, REVIEW_HOTELS_PER_PAGE)) return;
		state.set({reviewPage: current + offset});
	},
	reviewHotels: function(ev) {
		if (this.name === "HotelMinPop" && Number(this.value) >= Number(ev.data.state.HotelMaxPop)) {
			ev.data.state.HotelMaxPop = this.value;
		}
		setState.call(this, ev);
		Action.hotels.call(this, ev);
	},
	closeSubLayer: function(ev) {
		ev.data.state.set({subLayer: ""});
	},
	goHotelTours: function(ev) {
		const store = ev.data;
		// 既存の選択されているホテルは無視し、新規に選択されたホテルのみ
		// TODO ほんとはaタグじゃなくて、他に合わせてinputタグつかいたい
		let newHotel = [];
		const HotelCode = this.id.split("-")[1];
		newHotel.push(HotelCode);
		store.state.set({["pickedHotel"]: newHotel});
		store.state.checkedHotel = store.state.pickedHotel;
		store.state.set({["sort"]: "prlow"});
		store.state.set({["hotelOrderLastParam"]: store.state.getParam()});
		Action.list.call(this, ev);
		countAll(ev.data);
		initializePickedHotel(ev);
		View.modSortText(ev);
		$(window).scrollTop(top);
		View.currentConditions(ev);
		View.mainLayer(ev);
	},
	pickedHotel: function(ev) {
		const pickedHotel = ev.data.state[this.name] || [];
		const newHotels = this.checked ?
				_.unique(pickedHotel.concat([this.value])) :
				pickedHotel.filter((v) => (v !== this.value));
		ev.data.state.set({[this.name]: newHotels});
		View.goMultiHotelTours(ev, {
			isCheckOn: newHotels.length > pickedHotel.length,
			checkHotelCode: $(this).attr("id"),
			checkedCassette: $(this)
		});
	},
	goMultiHotelTours: function(ev) {
		const store = ev.data;
		store.state.checkedHotel = store.state.pickedHotel;
		const checkedHotel = store.state.checkedHotel || [];
		if(checkedHotel.length === 0) {
			alert("ホテルを選択してください");
		} else {
			store.state.set({["sort"]: "prlow"});
			store.state.set({["hotelOrderLastParam"]: store.state.getParam()});
			Action.list.call(this, ev);
			countAll(ev.data);
			initializePickedHotel(ev);
			View.modSortText(ev);
			$(window).scrollTop(top);
			View.currentConditions(ev);
			View.mainLayer(ev);
		}
	}
};


function showLoadImage(selector) {
	var style = [
		"width: 32px",
		"height: 32px",
		"margin: 20px auto",
		"background-image: url(/jal_intl/img/loading.gif)",
		"background-repeat: no-repeat"].join(";");
	$(selector).html("<div style='" + style + "'></div>");
}

function showCalendarLoadingImage(store) {
	const index = store.state.monthIndex;
	const id = `#forcia-template-calendar-month-${index}`;
	const loadingImageElm = ".forcia-calendar-loading";
	const selector = `${id} ${loadingImageElm}`;
	$(selector).show();
}

function hasNextPage(total, page, perPage) {
	return total > page * perPage;
}

function countAll(store) {
	showCalendarLoadingImage(store);
	store.state.skipSetFirstPage = false;
	return $.when(
		reviewHotelsCommand(store),
		spookCommand(store, "CalendarState", store.state.getParam("CalendarState")),
		spookCommand(store, "ConditionState", store.state.getParam("ConditionState")),
		spookCommand(store, "BudgetDurationState", store.state.getParam("BudgetDurationState"))
	);
}

function countAllWithoutSetPager(store) {
	showCalendarLoadingImage(store);
	store.state.skipSetFirstPage = true;
	return $.when(
		reviewHotelsCommand(store),
		spookCommand(store, "CalendarState", store.state.getParam("CalendarState")),
		spookCommand(store, "ConditionState", store.state.getParam("ConditionState")),
		spookCommand(store, "BudgetDurationState", store.state.getParam("BudgetDurationState"))
	);
}

function countWithoutUpdatingHotels(store) {
	showCalendarLoadingImage(store);
	return $.when(
		spookCommand(store, "CalendarState", store.state.getParam("CalendarState")),
		spookCommand(store, "ConditionState", store.state.getParam("ConditionState")),
		spookCommand(store, "BudgetDurationState", store.state.getParam("BudgetDurationState"))
	);
}

function getHistory(HIST_CONFIG) {
	const historyCookie = cookie.get(HIST_CONFIG.NAME);
	return historyCookie ?  historyCookie.split("-") : null;
}

function initHistory(store, HIST_CONFIG) {
	const history = getHistory(HIST_CONFIG);
	if (!history) return;

	const list = history.slice().reverse();
	request("HistListMobile", {
		data: Object.assign({courses: list.join("-")}, store.state.getParam()),
		callback: function(data) {
			store.state.set({HistListMobile: data});
		}
	});
}


function calendarState(store) {
	showCalendarLoadingImage(store);
	if (store.state.checkStock) {
		return $.when(
			spookCommand(store, "ConditionState", store.state.getParam("ConditionState")),
			spookCommand(store, "CalendarState", store.state.getParam("CalendarState"))
		);
	} else {
		return spookCommand(store, "CalendarState", store.state.getParam("CalendarState"));
	}
}


function reviewHotelsCommand(store) {
	const d = new $.Deferred;
	request("Hotels", {
		data: store.state.getParam(),
		callback: function(data) {
			store.state.set(data);
			d.resolve();
		},
		beforeSend: function() {
			showLoadImage("#forcia-template-review-hotels");
		}
	});
	return d.promise();
}

function setHistory(courseKey, HIST_CONFIG) {
	const history = getHistory(HIST_CONFIG) || [];
	if (history.indexOf(courseKey) >= 0 ) return;

	history.push(courseKey);
	if (history.length > HIST_CONFIG.MAX_LENGTH){
		history.shift();
	}
	cookie.set(HIST_CONFIG.NAME, history.join("-"), {
		expires: HIST_CONFIG.EXPIRES,
		path: "/jal_intl" //TODO PCと共有するかどうか確認.PC/SPともにpath指定がない方がよい
	});
}


const destHasChanged = (function() {
	var cachedParam = {
		region0: null,
		country0: null,
		city0: null,
		country1: null,
		city1: null
	};
	return function (param) {
		const newCache = {};
		for (let key in cachedParam) {
			newCache[key] = param[key];
			if (cachedParam[key] !== param[key]) {
				cachedParam = newCache;
				return true;
			}
		}
		cachedParam = newCache;
		return false;
	};
})();

function setConditionHash(store) {
	if (store.state.queryString) {
		location.href = `#${store.state.queryString}`;
	}
}

function initializePickedHotel(ev) {
	ev.data.state.set({["pickedHotel"]: []});
}

if (typeof module !== "undefined" && module.exports) {
	module.exports = Action;
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/search/action.js